import { css } from "@emotion/react"
import { breakpoints } from '~/utils/styles'
import { palette } from '~/utils/colors'

export const header = css`
    margin-top: 49px;
	@media (min-width: ${breakpoints.tablet}px) {
		margin-top: 56px;
	}
`;

export const tagName = css`
    margin-top: 30px;
    text-align: center;
    font-size: 1.8rem;
    line-height: 22.4px;
    font-weight: bold;
    color: ${palette.text.primary};
	@media (min-width: ${breakpoints.tablet}px) {
        display: none;
	}
`;

export const pageGrid = css`
    margin-top: 38px;
	display: grid;
	gap: 40px;
	@media (min-width: ${breakpoints.pc}px) {
        margin-top: 98px;
		grid-template-columns: 1fr 318px;
		gap: 0 68px;
	}
`;

export const newsList = css`
    display: grid;
    gap: 20px;
	@media (min-width: ${breakpoints.tablet}px) {
		grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 58px 38px;
	}
`;

export const newsItem = css`
    width: auto;
    min-width: auto;
	@media (min-width: ${breakpoints.tablet}px) {
		width: auto;
		min-width: auto;
	}
`;

export const pagination = css`
    margin-top: 40px;
	@media (min-width: ${breakpoints.tablet}px) {
		margin-top: 68px;
	}
`;

export const sectionTitle = css`
    font-size: 2rem;
    font-weight: bold;
    line-height: 40px;
    color: ${palette.text.primary};
`;

export const latestNewsList = css`
	margin-top: 12px;
    display: grid;
    gap: 18px;
`;

export const latestNewsItem = css`
    :hover {
        opacity: 0.7;
    }
`;

export const popularTagList = css`
    margin-top: 10px;
    display: flex;
    flex-wrap: wrap;
    gap: 8px 10px;
`;

export const popularNewsItem = css`
    :hover {
        opacity: 0.7;
    }
`;

export const popularKeywords = css``;

export const latestNews = css`
	margin-top: 20px;
`;

export const activeTag = css`
    border-color: ${palette.primary.light};
    color: ${palette.primary.light};
`;